module.exports = __webpack_public_path__ + "platform-web/static/media/dropup-grey.1790f8c0.svg";